import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DropDown, SelectAllState } from '../model/dropdown.model';

@Injectable()
export class DropdownService {
  isMenuOpened = new BehaviorSubject<boolean>(false);
  defaultValue: any = '';
  multiple: boolean = false;
  isSelectAll: boolean | null | undefined = false;
  dropDownState = new BehaviorSubject<DropDown>({
    selectedMenu: '',
  });
  isInputDirty: boolean = false;
  isInputBlur = new Subject<boolean>();
  isSearchable!: boolean;
  returnArray!: boolean;
  id: any;
  handleNA!: boolean;
  naValue: string = 'NA';

  checkNAHandle(value: string) {
    // if (this.handleNA) {
    //   if (value === 'NA') {
    //     return true;
    //   }
    //   return false;
    // } else {
    //   return false;
    // }
    return this.handleNA ? value === this.naValue : false;
  }

  dropDownValue = new BehaviorSubject<string>('');
  setDropDownValue(value: string) {
    this.dropDownValue.next(value);
  }

  setInputblur(flag: boolean) {
    this.isInputBlur.next(flag);
  }
  selectAllState = new BehaviorSubject<string | null>(null);

  setSelectAll(selectAll: string | null) {
    this.selectAllState.next(selectAll);
  }

  selectAll(id: string) {
    this.multipleValues.next([]);
    document.querySelectorAll(`#${id} app-menu-item`).forEach((el: any) => {
      if (
        el.getAttribute('data-select-all') !== 'true' &&
        !this.checkNAHandle(el.getAttribute('data-value'))
      ) {
        this.setMutiplesValues(el.getAttribute('data-value'));
      }
    });

    document
      .querySelectorAll(`#${id} input[type='checkbox']`)
      .forEach((el: any) => {
        el.checked = true;
        // Remove NA selection on click 'Select all' If handleNA is true
        if (this.checkNAHandle(el.getAttribute('data-value'))) {
          el.checked = false;
        }
      });
  }

  toggleSelectAll(isSelectAll: boolean) {
    if (this.id) {
      // isSelectAll&&this.multipleValues.next([]);
      document
        .querySelectorAll(`#${this.id} app-menu-item`)
        .forEach((el: any) => {
          if (el.getAttribute('data-select-all') === 'true') {
            el.querySelector("input[type='checkbox']").checked = isSelectAll;

            // isSelectAll&& this.setMutiplesValues(el.getAttribute('data-value'));
            // this.setSelectAll(el.getAttribute('data-value'));
          }
        });
    }
  }

  clearAllSelected(id: string) {
    document
      .querySelectorAll(`#${id} input[type='checkbox']`)
      .forEach((el: any) => {
        el.checked = false;
      });
    this.multipleValues.next([]);
  }

  multipleValues = new BehaviorSubject<any[]>([]);
  menuItems: any[] = [];
  setMenuItems(item: any) {
    if (!this.menuItems.includes(item)) {
      this.menuItems.push(item);
    }
  }
  getMenuItems(): any[] {
    return this.menuItems;
  }
  openMenu() {
    this.isMenuOpened.next(true);
  }
  closeMenu() {
    this.isMenuOpened.next(false);
  }
  toggelMenu() {
    const preVal = this.isMenuOpened.value;
    this.isMenuOpened.next(!preVal);
  }
  private setMutiplesValues(value: any) {
    const initialvalue = this.multipleValues.value;
    // setting everyting including NA
    if (value && value !== ' ' && !initialvalue.includes(value)) {
      initialvalue.push(value);
      // Filtering to remove NA

      // ---

      this.multipleValues.next(
        initialvalue.filter((val) =>
          this.handleNA ? val !== this.naValue : val
        )
      );
      const excludeCount =
        this.handleNA && this.getMenuItems().includes(this.naValue) ? 2 : 1;
      if (
        this.multiple &&
        this.getMenuItems().length > 1 &&
        this.getMenuItems().length - excludeCount ===
          this.multipleValues.value.length
      ) {
        this.toggleSelectAll(true);
      }
      if (!this.checkNAHandle(value)) {
        document
          .querySelectorAll(`#${this.id} input[type='checkbox']`)
          .forEach((el: any) => {
            if (el.getAttribute('data-value') === this.naValue) {
              el.checked = false;
            }
          });
      }
    }

    // removing everyting except NA
    if (this.checkNAHandle(value)) {
      this.multipleValues.next([value]);
      document
        .querySelectorAll(`#${this.id} input[type='checkbox']`)
        .forEach((el: any) => {
          if (el.getAttribute('data-value') !== this.naValue) {
            el.checked = false;
          }
        });
    }
  }
  removeMutipleValue(selectedVal: any) {
    const updatedMutlipleValue = this.multipleValues.value.filter(
      (val) => val !== selectedVal
    );
    this.multipleValues.next(updatedMutlipleValue);
    this.toggleSelectAll(false);
  }
  setSelectedMenu(value: string | number) {
    if (this.multiple) {
      this.setMutiplesValues(value);
    } else {
      const preVal: DropDown = this.dropDownState.value;
      preVal.selectedMenu = value;
      this.dropDownState.next(preVal);
    }
  }
  clearAllMutipleValues() {
    this.multipleValues.next([]);
  }
  isMenuItems() {
    return this.menuItems?.length > 0;
  }

  // ---------------------::TODO Disable Scroll --------------------------------------------------
  keys:any = { 37: 1, 38: 1, 39: 1, 40: 1 };

  preventDefault(e: any) {
    e.preventDefault();
  }

  preventDefaultForScrollKeys(e: any) {
    if (this?.keys[e?.keyCode]) {
      this.preventDefault(e);
      return false;
    }
    return false; 
  }
  supportsPassive = true;

  wheelOpt = this.supportsPassive ? { passive: false } : false;
  wheelEvent =
    'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  disableScroll() {
    document.body.addEventListener(
      'DOMMouseScroll',
      this.preventDefault,
      false
    ); // older FF
    document.body.addEventListener(
      this.wheelEvent,
      this.preventDefault,
      this.wheelOpt
    ); // modern desktop
    document.body.addEventListener(
      'touchmove',
      this.preventDefault,
      this.wheelOpt
    ); // mobile
    document.body.addEventListener(
      'keydown',
      this.preventDefaultForScrollKeys,
      { passive: false }
    );
  }

  // call this to Enable
  enableScroll() {
    document.body.addEventListener(
      'DOMMouseScroll',
      this.preventDefault,
      false
    ); // older FF
    document.body.removeEventListener(this.wheelEvent, this.preventDefault);
    document.body.removeEventListener('touchmove', this.preventDefault);
    document.body.removeEventListener(
      'keydown',
      this.preventDefaultForScrollKeys,
      false
    );
  }
  // --------------------------------------------------------------------------------------------------
  constructor() {}
}
